// Single source of truth for the branded engine count on the frontend.
// Mirrors backend server.py CATALOG_ENGINE_COUNT (218 legacy + 88 detect + 1 meta = 307).
// The constitution green-gate (chk_frontend_engine_count_matches) FAILS the build
// if any hardcoded engine-count string in frontend/src disagrees with this value,
// so the branded number can never silently drift again.
export const CATALOG_ENGINE_COUNT = 307;
export const ENGINE_COMPOSITION = { legacy: 218, detect: 88, meta: 1 };
